import { Button, FormControl, Grid, TextField, Select, MenuItem, InputLabel } from '@mui/material';
import { usePosMappingsContext } from '../../context/PosMappingsContext';
import { SearchSm } from '../../../../assets';


export function PosSkuMapping() {
  const {
    t,
    skuSearch,
    storeSearch,
    itemType,
    handleSkuSearchChange,
    handleStoreSearchChange,
    handleItemTypeChange,
    searchPOSMapping,
    clearAll,
  } = usePosMappingsContext();

  return (
    <Grid
      container
      spacing={5}
      sx={{
        pt: '12px', pb: '24px',
      }}
    >
      <Grid item
        xs={12}
        md={4}>
        <FormControl fullWidth
          size="small">
          <TextField
            size="small"
            id="sku-search"
            label={t('skuSearch')}
            variant="outlined"
            value={skuSearch}
            onChange={handleSkuSearchChange}
          />
        </FormControl>
      </Grid>

      <Grid item
        xs={12}
        md={4}>
        <FormControl fullWidth
          size="small">
          <TextField
            size="small"
            id="store-search"
            label={t('storeSearch')}
            variant="outlined"
            value={storeSearch}
            onChange={handleStoreSearchChange}
          />
        </FormControl>
      </Grid>

      <Grid item
        xs={12}
        md={4}>
        <FormControl fullWidth
          size="small">
          <InputLabel id="item-type-label">{t('itemType')}</InputLabel>
          <Select
            labelId="item-type-label"
            id="item-type-select"
            value={itemType ?? ''}
            label={t('itemType')}
            onChange={(e) => handleItemTypeChange(e.target.value === '' ? undefined : Number(e.target.value))}
          >
            <MenuItem value="">{t('all')}</MenuItem>
            <MenuItem value={1}>{t('standalone')}</MenuItem>
            <MenuItem value={2}>{t('extra')}</MenuItem>
            <MenuItem value={4}>{t('removal')}</MenuItem>
            <MenuItem value={5}>{t('swap')}</MenuItem>
            <MenuItem value={20}>{t('transition')}</MenuItem>
            <MenuItem value={30}>{t('substitution')}</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item
        xs={12}
        md={6}>
        <Button variant="secondary"
          size="lg"
          onClick={clearAll}
          fullWidth>
          {t('clearAll')}
        </Button>
      </Grid>

      <Grid item
        xs={12}
        md={6}>
        <Button
          variant="primary"
          size="lg"
          onClick={searchPOSMapping}
          startIcon={<SearchSm />}
          fullWidth
        >
          {t('search')}
        </Button>
      </Grid>
    </Grid>
  );
}
